__turbopack_context__.v({
  "buttons": "deletePortfolioModal-module-scss-module__ZPmhXq__buttons",
  "content": "deletePortfolioModal-module-scss-module__ZPmhXq__content",
  "deleteBtn": "deletePortfolioModal-module-scss-module__ZPmhXq__deleteBtn",
  "deleteBtnFetching": "deletePortfolioModal-module-scss-module__ZPmhXq__deleteBtnFetching",
  "description": "deletePortfolioModal-module-scss-module__ZPmhXq__description",
  "popoverArrow": "deletePortfolioModal-module-scss-module__ZPmhXq__popoverArrow",
  "popoverContent": "deletePortfolioModal-module-scss-module__ZPmhXq__popoverContent",
  "title": "deletePortfolioModal-module-scss-module__ZPmhXq__title",
  "wrapper": "deletePortfolioModal-module-scss-module__ZPmhXq__wrapper",
});
